/******/ (() => { // webpackBootstrap
/******/ 	"use strict";
/******/ 	// The require scope
/******/ 	var __webpack_require__ = {};
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/compat get default export */
/******/ 	(() => {
/******/ 		// getDefaultExport function for compatibility with non-harmony modules
/******/ 		__webpack_require__.n = (module) => {
/******/ 			var getter = module && module.__esModule ?
/******/ 				() => (module['default']) :
/******/ 				() => (module);
/******/ 			__webpack_require__.d(getter, { a: getter });
/******/ 			return getter;
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/define property getters */
/******/ 	(() => {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = (exports, definition) => {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	(() => {
/******/ 		__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	(() => {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = (exports) => {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	})();
/******/ 	
/************************************************************************/
var __webpack_exports__ = {};
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  CarouselClips: () => (/* reexport */ src),
  CarouselClipsAdapter: () => (/* reexport */ src_CarouselClipsAdapter),
  "default": () => (/* binding */ packages_CarouselClips)
});

;// CONCATENATED MODULE: external "@babel/runtime/helpers/objectSpread2"
const objectSpread2_namespaceObject = require("@babel/runtime/helpers/objectSpread2");
var objectSpread2_default = /*#__PURE__*/__webpack_require__.n(objectSpread2_namespaceObject);
;// CONCATENATED MODULE: external "react"
const external_react_namespaceObject = require("react");
;// CONCATENATED MODULE: external "prop-types"
const external_prop_types_namespaceObject = require("prop-types");
;// CONCATENATED MODULE: ./utils/melidata.js
/* global melidata */

/**
 * Event Tracker
 *
 * @param {String} path
 * @param {String} data
 * @param {String} clean
 *
 * If you send clean = true the event is going to change to cleanAndSend
 *
 * @example
 * trackEvent({
 *     path: '/search/listings/',
 *     data: {},
 * });
 */
function trackEvent() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    _ref$path = _ref.path,
    path = _ref$path === void 0 ? null : _ref$path,
    _ref$event_data = _ref.event_data,
    event_data = _ref$event_data === void 0 ? null : _ref$event_data,
    _ref$clean = _ref.clean,
    clean = _ref$clean === void 0 ? true : _ref$clean,
    _ref$type = _ref.type,
    type = _ref$type === void 0 ? 'event' : _ref$type,
    _ref$experiments = _ref.experiments,
    experiments = _ref$experiments === void 0 ? {} : _ref$experiments;
  // If melidata is not defined do nothing for now

  if (typeof melidata !== 'function') {
    return;
  }

  // If one of this parameters is empty do not track
  if (!path) {
    return;
  }
  var actionType = clean ? 'cleanAndSend' : 'send';
  if (event_data) {
    melidata(actionType, type, {
      path: path,
      event_data: event_data,
      experiments: experiments
    });
  } else {
    melidata(actionType, type, {
      path: path,
      experiments: experiments
    });
  }
}
function trackIdFromTrack(track) {
  if (!track || !track.melidata_event || !track.melidata_event.event_data) {
    return '';
  }
  return track.melidata_event.event_data.tracking_id;
}

;// CONCATENATED MODULE: external "@babel/runtime/helpers/jsx"
const jsx_namespaceObject = require("@babel/runtime/helpers/jsx");
var jsx_default = /*#__PURE__*/__webpack_require__.n(jsx_namespaceObject);
;// CONCATENATED MODULE: external "clsx"
const external_clsx_namespaceObject = require("clsx");
var external_clsx_default = /*#__PURE__*/__webpack_require__.n(external_clsx_namespaceObject);
;// CONCATENATED MODULE: external "uuid"
const external_uuid_namespaceObject = require("uuid");
;// CONCATENATED MODULE: external "swiper/react"
const react_namespaceObject = require("swiper/react");
;// CONCATENATED MODULE: external "swiper"
const external_swiper_namespaceObject = require("swiper");
;// CONCATENATED MODULE: ./packages/CarouselClips/src/hooks/useCarousel.js

var clipsReproductionHandler = function clipsReproductionHandler(swiper, videoElementsRef) {
  if (!swiper || !videoElementsRef) return;
  videoElementsRef.forEach(function (item) {
    return item.pause();
  });
  if (swiper.activeIndex === 0 || swiper.activeIndex) {
    var _videoElementsRef$swi, _videoElementsRef;
    (_videoElementsRef$swi = videoElementsRef[swiper.activeIndex]) === null || _videoElementsRef$swi === void 0 || (_videoElementsRef$swi = _videoElementsRef$swi.play()) === null || _videoElementsRef$swi === void 0 || _videoElementsRef$swi["catch"](function (err) {
      return console.log(err);
    });
    (_videoElementsRef = videoElementsRef[swiper.activeIndex + 1]) === null || _videoElementsRef === void 0 || (_videoElementsRef = _videoElementsRef.play()) === null || _videoElementsRef === void 0 || _videoElementsRef["catch"](function (err) {
      return console.log(err);
    });
  }
};
var useCarousel = function useCarousel() {
  var swiperRef = (0,external_react_namespaceObject.useRef)(null);
  var videoElementsRef = (0,external_react_namespaceObject.useRef)([]);
  var getSwiperRef = function getSwiperRef() {
    return swiperRef === null ? {} : swiperRef.current;
  };
  var getVideoElementsRef = function getVideoElementsRef() {
    return videoElementsRef === null ? [] : videoElementsRef.current;
  };
  var onCarouselReachBegining = function onCarouselReachBegining(swiper) {
    var _videoElementsRef$cur, _videoElementsRef$cur2;
    videoElementsRef.current.forEach(function (item) {
      return item.pause();
    });
    videoElementsRef === null || videoElementsRef === void 0 || (_videoElementsRef$cur = videoElementsRef.current[0]) === null || _videoElementsRef$cur === void 0 || (_videoElementsRef$cur = _videoElementsRef$cur.play()) === null || _videoElementsRef$cur === void 0 || _videoElementsRef$cur["catch"](function (err) {
      return console.log(err);
    });
    videoElementsRef === null || videoElementsRef === void 0 || (_videoElementsRef$cur2 = videoElementsRef.current[1]) === null || _videoElementsRef$cur2 === void 0 || (_videoElementsRef$cur2 = _videoElementsRef$cur2.play()) === null || _videoElementsRef$cur2 === void 0 || _videoElementsRef$cur2["catch"](function (err) {
      return console.log(err);
    });
    swiper.update();
  };
  var onCarouselReachEnd = function onCarouselReachEnd(swiper) {
    var _videoElementsRef$cur3, _videoElementsRef$cur4, _videoElementsRef$cur5, _videoElementsRef$cur6;
    videoElementsRef === null || videoElementsRef === void 0 || videoElementsRef.current.forEach(function (item) {
      return item.pause();
    });
    videoElementsRef === null || videoElementsRef === void 0 || (_videoElementsRef$cur3 = videoElementsRef.current[(videoElementsRef === null || videoElementsRef === void 0 || (_videoElementsRef$cur4 = videoElementsRef.current) === null || _videoElementsRef$cur4 === void 0 ? void 0 : _videoElementsRef$cur4.length) - 1]) === null || _videoElementsRef$cur3 === void 0 || (_videoElementsRef$cur3 = _videoElementsRef$cur3.play()) === null || _videoElementsRef$cur3 === void 0 || _videoElementsRef$cur3["catch"](function (err) {
      return console.log(err);
    });
    videoElementsRef === null || videoElementsRef === void 0 || (_videoElementsRef$cur5 = videoElementsRef.current[(videoElementsRef === null || videoElementsRef === void 0 || (_videoElementsRef$cur6 = videoElementsRef.current) === null || _videoElementsRef$cur6 === void 0 ? void 0 : _videoElementsRef$cur6.length) - 2]) === null || _videoElementsRef$cur5 === void 0 || (_videoElementsRef$cur5 = _videoElementsRef$cur5.play()) === null || _videoElementsRef$cur5 === void 0 || _videoElementsRef$cur5["catch"](function (err) {
      return console.log(err);
    });
    swiper.update();
  };
  var onCarouselInit = function onCarouselInit(swiper, containerRef, autoplay) {
    if (!autoplay) return;
    swiperRef.current = swiper;
    setTimeout(function () {
      var _videoElementsRef$cur7;
      if ((videoElementsRef === null || videoElementsRef === void 0 || (_videoElementsRef$cur7 = videoElementsRef.current) === null || _videoElementsRef$cur7 === void 0 ? void 0 : _videoElementsRef$cur7.length) === 0 && containerRef !== null && containerRef !== void 0 && containerRef.current) {
        var _containerRef$current;
        videoElementsRef.current = containerRef === null || containerRef === void 0 || (_containerRef$current = containerRef.current) === null || _containerRef$current === void 0 ? void 0 : _containerRef$current.querySelectorAll('video');
      }
      onCarouselReachBegining(swiper);
    }, 1000);
  };
  var onCarouselMoveHandler = function onCarouselMoveHandler(containerRef) {
    var _videoElementsRef$cur8;
    if (!(containerRef !== null && containerRef !== void 0 && containerRef.current)) return;
    if ((videoElementsRef === null || videoElementsRef === void 0 || (_videoElementsRef$cur8 = videoElementsRef.current) === null || _videoElementsRef$cur8 === void 0 ? void 0 : _videoElementsRef$cur8.length) === 0) {
      videoElementsRef.current = containerRef.current.querySelectorAll('video');
    }
    clipsReproductionHandler(swiperRef.current, videoElementsRef.current);
  };
  var onCarouselFirstTouch = function onCarouselFirstTouch(swiper) {
    swiper.update();
  };
  var startListVideos = function startListVideos(containerRef) {
    if (!(containerRef !== null && containerRef !== void 0 && containerRef.current)) return;
    videoElementsRef.current = containerRef.current.querySelectorAll('video');
    videoElementsRef.current.forEach(function (item) {
      var _item$play;
      return item === null || item === void 0 || (_item$play = item.play()) === null || _item$play === void 0 ? void 0 : _item$play["catch"](function (err) {
        return console.log(err);
      });
    });
  };
  return {
    onCarouselInit: onCarouselInit,
    onCarouselMoveHandler: onCarouselMoveHandler,
    onCarouselReachBegining: onCarouselReachBegining,
    onCarouselReachEnd: onCarouselReachEnd,
    getSwiperRef: getSwiperRef,
    getVideoElementsRef: getVideoElementsRef,
    onCarouselFirstTouch: onCarouselFirstTouch,
    startListVideos: startListVideos
  };
};
/* harmony default export */ const hooks_useCarousel = (useCarousel);

;// CONCATENATED MODULE: external "@babel/runtime/helpers/slicedToArray"
const slicedToArray_namespaceObject = require("@babel/runtime/helpers/slicedToArray");
var slicedToArray_default = /*#__PURE__*/__webpack_require__.n(slicedToArray_namespaceObject);
;// CONCATENATED MODULE: external "frontend-image"
const external_frontend_image_namespaceObject = require("frontend-image");
;// CONCATENATED MODULE: external "@andes/typography"
const typography_namespaceObject = require("@andes/typography");
;// CONCATENATED MODULE: external "video.js"
const external_video_js_namespaceObject = require("video.js");
var external_video_js_default = /*#__PURE__*/__webpack_require__.n(external_video_js_namespaceObject);
;// CONCATENATED MODULE: external "react/jsx-runtime"
const jsx_runtime_namespaceObject = require("react/jsx-runtime");
;// CONCATENATED MODULE: ./packages/CarouselClips/src/components/VideoJS/VideoJS.js






var VideoJS = function VideoJS(_ref) {
  var options = _ref.options,
    onError = _ref.onError,
    onPlaying = _ref.onPlaying;
  var videoRef = (0,external_react_namespaceObject.useRef)(null);
  var playerRef = (0,external_react_namespaceObject.useRef)(null);
  (0,external_react_namespaceObject.useEffect)(function () {
    // Make sure Video.js player is only initialized once
    if (!playerRef.current) {
      // The Video.js player needs to be _inside_ the component el for React 18 Strict Mode.
      var videoElement = document.createElement('video-js');
      videoElement.classList.add('vjs-big-play-centered');
      videoRef.current.appendChild(videoElement);
      playerRef.current = external_video_js_default()(videoElement, objectSpread2_default()(objectSpread2_default()({}, options), {}, {
        playsinline: true
      }));
      playerRef.current.on('error', onError);
      playerRef.current.on('playing', onPlaying);
    }
  }, [options, videoRef]);

  // Dispose the Video.js player when the functional component unmounts
  (0,external_react_namespaceObject.useEffect)(function () {
    return function () {
      if (playerRef.current && !playerRef.current.isDisposed()) {
        playerRef.current.dispose();
        playerRef.current = null;
      }
    };
  }, [playerRef]);
  return /*#__PURE__*/jsx_default()("div", {
    "data-vjs-player": true
  }, void 0, /*#__PURE__*/(0,jsx_runtime_namespaceObject.jsx)("div", {
    ref: videoRef
  }));
};
VideoJS.defaultProps = {
  options: {},
  onError: function onError() {},
  onPlaying: function onPlaying() {}
};
/* harmony default export */ const VideoJS_VideoJS = (VideoJS);
;// CONCATENATED MODULE: external "@babel/runtime/helpers/objectWithoutProperties"
const objectWithoutProperties_namespaceObject = require("@babel/runtime/helpers/objectWithoutProperties");
var objectWithoutProperties_default = /*#__PURE__*/__webpack_require__.n(objectWithoutProperties_namespaceObject);
;// CONCATENATED MODULE: ./packages/CarouselClips/src/components/Icon/Icons/ClipsIcon.js


var _g, _g2, _defs, _defs2;



var ClipsIcon = function ClipsIcon(props) {
  return /*#__PURE__*/(0,jsx_runtime_namespaceObject.jsxs)("svg", objectSpread2_default()(objectSpread2_default()({}, props), {}, {
    className: "clips-icon",
    fill: "none",
    height: "20",
    viewBox: "0 0 22 22",
    width: "14",
    xmlns: "http://www.w3.org/2000/svg",
    children: [_g || (_g = _g2 || (_g2 = /*#__PURE__*/jsx_default()("g", {
      filter: "url(#filter0_dii_1516_11353)"
    }, void 0, /*#__PURE__*/jsx_default()("path", {
      d: "M5.1454 12.3286H8.20738V19.8019C8.20738 20.9022 9.51541 21.4212 10.2091 20.5908L17.7104 11.6643C18.3644 10.8858 17.8392 9.67141 16.8483 9.67141H13.7863V2.19807C13.7863 1.09782 12.4783 0.578843 11.7846 1.40921L4.28328 10.3357C3.63918 11.1142 4.16437 12.3286 5.1454 12.3286Z",
      fill: "url(#paint0_linear_1516_11353)"
    })))), _defs || (_defs = _defs2 || (_defs2 = /*#__PURE__*/jsx_default()("defs", {}, void 0, /*#__PURE__*/jsx_default()("filter", {
      colorInterpolationFilters: "sRGB",
      filterUnits: "userSpaceOnUse",
      height: "31.82",
      id: "filter0_dii_1516_11353",
      width: "25.82",
      x: "-1.91",
      y: "-1.95"
    }, void 0, /*#__PURE__*/jsx_default()("feFlood", {
      floodOpacity: "0",
      result: "BackgroundImageFix"
    }), /*#__PURE__*/jsx_default()("feColorMatrix", {
      "in": "SourceAlpha",
      result: "hardAlpha",
      type: "matrix",
      values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
    }), /*#__PURE__*/jsx_default()("feOffset", {
      dy: "2.96"
    }), /*#__PURE__*/jsx_default()("feGaussianBlur", {
      stdDeviation: "2.955"
    }), /*#__PURE__*/jsx_default()("feComposite", {
      in2: "hardAlpha",
      operator: "out"
    }), /*#__PURE__*/jsx_default()("feColorMatrix", {
      type: "matrix",
      values: "0 0 0 0 0.180392 0 0 0 0 0.0470588 0 0 0 0 0.113725 0 0 0 0.1 0"
    }), /*#__PURE__*/jsx_default()("feBlend", {
      in2: "BackgroundImageFix",
      mode: "normal",
      result: "effect1_dropShadow_1516_11353"
    }), /*#__PURE__*/jsx_default()("feBlend", {
      "in": "SourceGraphic",
      in2: "effect1_dropShadow_1516_11353",
      mode: "normal",
      result: "shape"
    }), /*#__PURE__*/jsx_default()("feColorMatrix", {
      "in": "SourceAlpha",
      result: "hardAlpha",
      type: "matrix",
      values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
    }), /*#__PURE__*/jsx_default()("feOffset", {
      dy: "-0.92"
    }), /*#__PURE__*/jsx_default()("feGaussianBlur", {
      stdDeviation: "0.46"
    }), /*#__PURE__*/jsx_default()("feComposite", {
      in2: "hardAlpha",
      k2: "-1",
      k3: "1",
      operator: "arithmetic"
    }), /*#__PURE__*/jsx_default()("feColorMatrix", {
      type: "matrix",
      values: "0 0 0 0 0.4875 0 0 0 0 0.0934375 0 0 0 0 0.133313 0 0 0 1 0"
    }), /*#__PURE__*/jsx_default()("feBlend", {
      in2: "shape",
      mode: "normal",
      result: "effect2_innerShadow_1516_11353"
    }), /*#__PURE__*/jsx_default()("feColorMatrix", {
      "in": "SourceAlpha",
      result: "hardAlpha",
      type: "matrix",
      values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
    }), /*#__PURE__*/jsx_default()("feOffset", {
      dy: "0.92"
    }), /*#__PURE__*/jsx_default()("feGaussianBlur", {
      stdDeviation: "0.46"
    }), /*#__PURE__*/jsx_default()("feComposite", {
      in2: "hardAlpha",
      k2: "-1",
      k3: "1",
      operator: "arithmetic"
    }), /*#__PURE__*/jsx_default()("feColorMatrix", {
      type: "matrix",
      values: "0 0 0 0 0.980392 0 0 0 0 0.247059 0 0 0 0 0.321569 0 0 0 1 0"
    }), /*#__PURE__*/jsx_default()("feBlend", {
      in2: "effect2_innerShadow_1516_11353",
      mode: "normal",
      result: "effect3_innerShadow_1516_11353"
    })), /*#__PURE__*/jsx_default()("linearGradient", {
      gradientUnits: "userSpaceOnUse",
      id: "paint0_linear_1516_11353",
      x1: "11",
      x2: "11",
      y1: "1",
      y2: "21"
    }, void 0, /*#__PURE__*/jsx_default()("stop", {
      stopColor: "#E33A4A"
    }), /*#__PURE__*/jsx_default()("stop", {
      offset: "1",
      stopColor: "#ED3C4E"
    })))))]
  }));
};
ClipsIcon.defaultProps = {
  id: '',
  alt: 'Clips icon'
};
/* harmony default export */ const Icons_ClipsIcon = (ClipsIcon);
;// CONCATENATED MODULE: ./packages/CarouselClips/src/components/Icon/Icons/ClipsXLIcon.js


var ClipsXLIcon_g, ClipsXLIcon_g2, ClipsXLIcon_defs, ClipsXLIcon_defs2;



var ClipsXLIcon = function ClipsXLIcon(props) {
  return /*#__PURE__*/(0,jsx_runtime_namespaceObject.jsxs)("svg", objectSpread2_default()(objectSpread2_default()({}, props), {}, {
    className: "clips-icon",
    fill: "none",
    height: "22",
    viewBox: "0 0 22 22",
    width: "22",
    xmlns: "http://www.w3.org/2000/svg",
    children: [ClipsXLIcon_g || (ClipsXLIcon_g = ClipsXLIcon_g2 || (ClipsXLIcon_g2 = /*#__PURE__*/jsx_default()("g", {
      filter: "url(#filter0_dii_8599_175365)"
    }, void 0, /*#__PURE__*/jsx_default()("path", {
      d: "M5.1454 12.3286H8.20738V19.8019C8.20738 20.9022 9.51541 21.4212 10.2091 20.5908L17.7104 11.6643C18.3644 10.8858 17.8392 9.67141 16.8483 9.67141H13.7863V2.19807C13.7863 1.09782 12.4783 0.578843 11.7846 1.40921L4.28328 10.3357C3.63918 11.1142 4.16437 12.3286 5.1454 12.3286Z",
      fill: "url(#paint0_linear_8599_175365)"
    })))), ClipsXLIcon_defs || (ClipsXLIcon_defs = ClipsXLIcon_defs2 || (ClipsXLIcon_defs2 = /*#__PURE__*/jsx_default()("defs", {}, void 0, /*#__PURE__*/jsx_default()("filter", {
      "color-interpolation-filters": "sRGB",
      filterUnits: "userSpaceOnUse",
      height: "31.82",
      id: "filter0_dii_8599_175365",
      width: "25.82",
      x: "-1.91",
      y: "-1.95"
    }, void 0, /*#__PURE__*/jsx_default()("feFlood", {
      "flood-opacity": "0",
      result: "BackgroundImageFix"
    }), /*#__PURE__*/jsx_default()("feColorMatrix", {
      "in": "SourceAlpha",
      result: "hardAlpha",
      type: "matrix",
      values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
    }), /*#__PURE__*/jsx_default()("feOffset", {
      dy: "2.96"
    }), /*#__PURE__*/jsx_default()("feGaussianBlur", {
      stdDeviation: "2.955"
    }), /*#__PURE__*/jsx_default()("feComposite", {
      in2: "hardAlpha",
      operator: "out"
    }), /*#__PURE__*/jsx_default()("feColorMatrix", {
      type: "matrix",
      values: "0 0 0 0 0.180392 0 0 0 0 0.0470588 0 0 0 0 0.113725 0 0 0 0.1 0"
    }), /*#__PURE__*/jsx_default()("feBlend", {
      in2: "BackgroundImageFix",
      mode: "normal",
      result: "effect1_dropShadow_8599_175365"
    }), /*#__PURE__*/jsx_default()("feBlend", {
      "in": "SourceGraphic",
      in2: "effect1_dropShadow_8599_175365",
      mode: "normal",
      result: "shape"
    }), /*#__PURE__*/jsx_default()("feColorMatrix", {
      "in": "SourceAlpha",
      result: "hardAlpha",
      type: "matrix",
      values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
    }), /*#__PURE__*/jsx_default()("feOffset", {
      dy: "-0.92"
    }), /*#__PURE__*/jsx_default()("feGaussianBlur", {
      stdDeviation: "0.46"
    }), /*#__PURE__*/jsx_default()("feComposite", {
      in2: "hardAlpha",
      k2: "-1",
      k3: "1",
      operator: "arithmetic"
    }), /*#__PURE__*/jsx_default()("feColorMatrix", {
      type: "matrix",
      values: "0 0 0 0 0.4875 0 0 0 0 0.0934375 0 0 0 0 0.133313 0 0 0 1 0"
    }), /*#__PURE__*/jsx_default()("feBlend", {
      in2: "shape",
      mode: "normal",
      result: "effect2_innerShadow_8599_175365"
    }), /*#__PURE__*/jsx_default()("feColorMatrix", {
      "in": "SourceAlpha",
      result: "hardAlpha",
      type: "matrix",
      values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
    }), /*#__PURE__*/jsx_default()("feOffset", {
      dy: "0.92"
    }), /*#__PURE__*/jsx_default()("feGaussianBlur", {
      stdDeviation: "0.46"
    }), /*#__PURE__*/jsx_default()("feComposite", {
      in2: "hardAlpha",
      k2: "-1",
      k3: "1",
      operator: "arithmetic"
    }), /*#__PURE__*/jsx_default()("feColorMatrix", {
      type: "matrix",
      values: "0 0 0 0 0.980392 0 0 0 0 0.247059 0 0 0 0 0.321569 0 0 0 1 0"
    }), /*#__PURE__*/jsx_default()("feBlend", {
      in2: "effect2_innerShadow_8599_175365",
      mode: "normal",
      result: "effect3_innerShadow_8599_175365"
    })), /*#__PURE__*/jsx_default()("linearGradient", {
      gradientUnits: "userSpaceOnUse",
      id: "paint0_linear_8599_175365",
      x1: "11",
      x2: "11",
      y1: "1",
      y2: "21"
    }, void 0, /*#__PURE__*/jsx_default()("stop", {
      "stop-color": "#E33A4A"
    }), /*#__PURE__*/jsx_default()("stop", {
      offset: "1",
      "stop-color": "#ED3C4E"
    })))))]
  }));
};
ClipsXLIcon.defaultProps = {
  id: '',
  alt: 'Clips icon'
};
/* harmony default export */ const Icons_ClipsXLIcon = (ClipsXLIcon);
;// CONCATENATED MODULE: external "@andes/icons/ChevronRight24"
const ChevronRight24_namespaceObject = require("@andes/icons/ChevronRight24");
var ChevronRight24_default = /*#__PURE__*/__webpack_require__.n(ChevronRight24_namespaceObject);
;// CONCATENATED MODULE: ./packages/CarouselClips/src/components/Icon/Icons/RigthArrowIcon.js





var RightArrowIcon = function RightArrowIcon(props) {
  return /*#__PURE__*/(0,jsx_runtime_namespaceObject.jsx)((ChevronRight24_default()), objectSpread2_default()({
    color: "#3483FA"
  }, props));
};
RightArrowIcon.defaultProps = {
  id: '',
  alt: 'chevron right icon'
};
/* harmony default export */ const RigthArrowIcon = (RightArrowIcon);
;// CONCATENATED MODULE: ./packages/CarouselClips/src/components/Icon/Icons/ArrowDown.js


var _path, _path2;



var ArrowDownIcon = function ArrowDownIcon(props) {
  return /*#__PURE__*/(0,jsx_runtime_namespaceObject.jsx)("svg", objectSpread2_default()(objectSpread2_default()({}, props), {}, {
    fill: "none",
    height: "10",
    viewBox: "0 0 10 10",
    width: "10",
    xmlns: "http://www.w3.org/2000/svg",
    children: _path || (_path = _path2 || (_path2 = /*#__PURE__*/jsx_default()("path", {
      clipRule: "evenodd",
      d: "M5.59989 0.147034V7.54936L8.52794 4.62131L9.37646 5.46984L4.99987 9.84643L0.623507 5.46965L1.47208 4.62116L4.39989 7.54926V0.147034H5.59989Z",
      fill: "black",
      fillOpacity: "0.55",
      fillRule: "evenodd"
    })))
  }));
};
ArrowDownIcon.defaultProps = {
  id: '',
  alt: 'arrow down icon'
};
/* harmony default export */ const ArrowDown = (ArrowDownIcon);
;// CONCATENATED MODULE: ./packages/CarouselClips/src/components/Icon/Icons/PlayIcon.js


var _circle, _circle2, PlayIcon_path, PlayIcon_path2;



var PlayIcon = function PlayIcon(props) {
  return /*#__PURE__*/(0,jsx_runtime_namespaceObject.jsxs)("svg", objectSpread2_default()(objectSpread2_default()({}, props), {}, {
    fill: "none",
    height: "32",
    viewBox: "0 0 40 40",
    width: "32",
    xmlns: "http://www.w3.org/2000/svg",
    children: [_circle || (_circle = _circle2 || (_circle2 = /*#__PURE__*/jsx_default()("circle", {
      cx: "20",
      cy: "20",
      fill: "black",
      "fill-opacity": "0.55",
      r: "18.75",
      stroke: "white",
      "stroke-width": "1.5"
    }))), PlayIcon_path || (PlayIcon_path = PlayIcon_path2 || (PlayIcon_path2 = /*#__PURE__*/jsx_default()("path", {
      d: "M13.25 30.9125V9.3125L31.25 20.1125L13.25 30.9125Z",
      fill: "white"
    })))]
  }));
};
PlayIcon.defaultProps = {
  id: '',
  alt: 'Play icon'
};
/* harmony default export */ const Icons_PlayIcon = (PlayIcon);
;// CONCATENATED MODULE: ./packages/CarouselClips/src/components/Icon/Icon.js


var _excluded = ["id"];








var availableIcons = {
  CHEVRON_RIGHT: RigthArrowIcon,
  CLIPS_LOGO: Icons_ClipsIcon,
  CLIPS_XL_LOGO: Icons_ClipsXLIcon,
  ARROW_DOWN: ArrowDown,
  PLAY: Icons_PlayIcon
};
var useAvailableIcon = function useAvailableIcon(id) {
  return availableIcons[id];
};
var Icon = function Icon(_ref) {
  var id = _ref.id,
    props = objectWithoutProperties_default()(_ref, _excluded);
  var Component = useAvailableIcon(id);
  return /*#__PURE__*/(0,jsx_runtime_namespaceObject.jsx)(Component, objectSpread2_default()({}, props));
};
Icon.defaultProps = {
  id: null,
  alt: null
};
/* harmony default export */ const Icon_Icon = (Icon);
;// CONCATENATED MODULE: ./packages/CarouselClips/src/constants/index.js

var CAROUSEL_TYPES = {
  CARD: 'CARD',
  FLAT: 'FLAT'
};
var AUTOPLAY_PROP = {
  TYPE: external_prop_types_namespaceObject.bool,
  DEFAULT_VALUE: true
};
var ICON_IDs = {
  PLAY: 'PLAY'
};
;// CONCATENATED MODULE: ./packages/CarouselClips/src/components/Clip/Clip.js


var _div, _div2;








var classname = 'ui-ms-clip-item';
var Clip = function Clip(_ref) {
  var autoplay = _ref.autoplay,
    label = _ref.label,
    sources = _ref.sources,
    poster = _ref.poster,
    action = _ref.action;
  var target = action.target,
    track = action.track;
  var _useState = (0,external_react_namespaceObject.useState)(true),
    _useState2 = slicedToArray_default()(_useState, 2),
    showFirstFrame = _useState2[0],
    setShowFirstFrame = _useState2[1];
  var _useState3 = (0,external_react_namespaceObject.useState)(false),
    _useState4 = slicedToArray_default()(_useState3, 2),
    usePoster = _useState4[0],
    setUsePoster = _useState4[1];
  var onPlaying = function onPlaying() {
    setShowFirstFrame(false);
  };
  var onError = function onError() {
    setUsePoster("production" !== 'test');
  };
  var onClickHandler = function onClickHandler() {
    if (track) {
      trackEvent(track === null || track === void 0 ? void 0 : track.melidata_event);
    }
  };
  var videoJsOptions = {
    muted: true,
    controls: false,
    responsive: true,
    fluid: true,
    sources: sources,
    loop: true,
    preload: 'metadata',
    height: '248px',
    width: '164px',
    aspectRatio: '9:16',
    html5: {
      vhs: {
        bandwidth: 600000,
        enableLowInitialPlaylist: true,
        fastQualityChange: true,
        useBandwidthFromLocalStorage: true
      }
    }
  };

  // only for test
  (0,external_react_namespaceObject.useEffect)(function () {
    if (false) {}
  }, []);
  var posterUrl = poster === null || poster === void 0 ? void 0 : poster.src_autoplay;
  if (autoplay && showFirstFrame) {
    posterUrl = poster === null || poster === void 0 ? void 0 : poster.src_cover;
  }
  return /*#__PURE__*/jsx_default()("a", {
    "data-testid": "clips-card",
    href: target,
    onClick: onClickHandler
  }, void 0, /*#__PURE__*/jsx_default()("div", {
    className: classname
  }, void 0, /*#__PURE__*/jsx_default()("div", {
    className: "".concat(classname, "__overlay")
  }, void 0, /*#__PURE__*/jsx_default()(typography_namespaceObject.Text, {
    className: "".concat(classname, "__label")
  }, void 0, label.text), _div || (_div = _div2 || (_div2 = /*#__PURE__*/jsx_default()("div", {
    className: "".concat(classname, "__gradient")
  })))), !autoplay && /*#__PURE__*/jsx_default()("div", {
    className: "".concat(classname, "__play_button")
  }, void 0, /*#__PURE__*/jsx_default()(Icon_Icon, {
    id: ICON_IDs.PLAY
  })), /*#__PURE__*/jsx_default()("div", {
    className: "".concat(classname, "__video-container")
  }, void 0, (usePoster || showFirstFrame || !autoplay) && /*#__PURE__*/jsx_default()(external_frontend_image_namespaceObject.Image, {
    className: "videojs-image-poster",
    lazyload: "off",
    src: posterUrl
  }), !usePoster && autoplay && /*#__PURE__*/jsx_default()(VideoJS_VideoJS, {
    options: videoJsOptions,
    onError: onError,
    onPlaying: onPlaying
  }))));
};
Clip.defaultProps = {
  autoplay: AUTOPLAY_PROP.DEFAULT_VALUE,
  label: {},
  sources: [],
  poster: {},
  action: {}
};
/* harmony default export */ const Clip_Clip = (Clip);
;// CONCATENATED MODULE: ./packages/CarouselClips/src/components/SlidesList/SlidesList.js






function SlidesList(_ref) {
  var id = _ref.id,
    autoplay = _ref.autoplay,
    items = _ref.items;
  var _useCarousel = hooks_useCarousel(),
    startListVideos = _useCarousel.startListVideos;
  var containerRef = (0,external_react_namespaceObject.useRef)();
  (0,external_react_namespaceObject.useEffect)(function () {
    setTimeout(function () {
      startListVideos(containerRef);
    }, 1000);
  }, []);
  return /*#__PURE__*/(0,jsx_runtime_namespaceObject.jsx)("ul", {
    className: "ui-slides-list",
    ref: containerRef,
    children: items.map(function (item) {
      return /*#__PURE__*/jsx_default()("li", {}, void 0, /*#__PURE__*/(0,jsx_runtime_namespaceObject.jsx)(Clip_Clip, objectSpread2_default()({
        autoplay: autoplay
      }, item)));
    })
  });
}
;// CONCATENATED MODULE: ./packages/CarouselClips/src/components/Carousel/Carousel.js













var namespace = 'ui-ms-clips-carousel';
var Carousel = function Carousel(_ref) {
  var autoplay = _ref.autoplay,
    items = _ref.items,
    behavior = _ref.behavior;
  var containerRef = (0,external_react_namespaceObject.useRef)();
  var _useCarousel = useCarousel(),
    onCarouselInit = _useCarousel.onCarouselInit,
    onCarouselMoveHandler = _useCarousel.onCarouselMoveHandler,
    onCarouselReachBegining = _useCarousel.onCarouselReachBegining,
    onCarouselReachEnd = _useCarousel.onCarouselReachEnd,
    onCarouselFirstTouch = _useCarousel.onCarouselFirstTouch;
  var classname = external_clsx_default()("".concat(namespace, "__slider-container"), {
    disable_swipe: (items === null || items === void 0 ? void 0 : items.length) < 3
  });
  return /*#__PURE__*/(0,jsx_runtime_namespaceObject.jsxs)("div", {
    className: classname,
    ref: containerRef,
    children: [(items === null || items === void 0 ? void 0 : items.length) >= 3 && /*#__PURE__*/jsx_default()(react_namespaceObject.Swiper, {
      freeMode: true,
      freeModeMomentumVelocityRatio: 2,
      modules: [external_swiper_namespaceObject.FreeMode],
      slidesOffsetAfter: 20,
      slidesOffsetBefore: 20,
      slidesPerView: 'auto',
      onActiveIndexChange: function onActiveIndexChange() {
        return onCarouselMoveHandler(containerRef);
      },
      onAfterInit: function onAfterInit(swiper) {
        return onCarouselInit(swiper, containerRef, autoplay);
      },
      onReachBeginning: onCarouselReachBegining,
      onReachEnd: onCarouselReachEnd,
      onTouchStart: onCarouselFirstTouch
    }, void 0, items.map(function (item) {
      return /*#__PURE__*/jsx_default()(react_namespaceObject.SwiperSlide, {
        className: "".concat(namespace, "__slide")
      }, "clip-card-".concat(item.id), /*#__PURE__*/(0,jsx_runtime_namespaceObject.jsx)(Clip_Clip, objectSpread2_default()({
        autoplay: autoplay
      }, item)));
    })), (items === null || items === void 0 ? void 0 : items.length) < 3 && /*#__PURE__*/jsx_default()(SlidesList, {
      autoplay: autoplay,
      items: items
    })]
  });
};
Carousel.defaultProps = {
  id: null,
  items: [],
  autoplay: AUTOPLAY_PROP.DEFAULT_VALUE
};
/* harmony default export */ const Carousel_Carousel = (Carousel);
;// CONCATENATED MODULE: ./packages/CarouselClips/src/components/Header/Header.js




var Header_classname = 'ui-ms-clips-carousel__header';
var Header = function Header(_ref) {
  var text = _ref.text;
  return /*#__PURE__*/jsx_default()(typography_namespaceObject.Typography, {
    className: Header_classname,
    component: "span",
    size: "m",
    weight: "semibold"
  }, void 0, text);
};
Header.defaultProps = {
  text: ''
};
/* harmony default export */ const Header_Header = (Header);
;// CONCATENATED MODULE: ./packages/CarouselClips/src/components/CarouselHeader/CarouselHeader.js








var CarouselHeader_classname = 'ui-ms-clips-carousel';
var CarouselHeader = function CarouselHeader(_ref) {
  var header = _ref.header,
    viewMore = _ref.viewMore,
    showArrow = _ref.showArrow,
    type = _ref.type;
  var icon = objectSpread2_default()({}, header === null || header === void 0 ? void 0 : header.icon);
  if (type === 'CARD' && icon.id === 'CLIPS_LOGO') {
    icon.id = 'CLIPS_XL_LOGO';
  }
  return /*#__PURE__*/jsx_default()("div", {
    className: "".concat(CarouselHeader_classname, "__header-container")
  }, void 0, /*#__PURE__*/jsx_default()("div", {
    className: "".concat(CarouselHeader_classname, "__title")
  }, void 0, /*#__PURE__*/jsx_default()("div", {
    className: "".concat(CarouselHeader_classname, "__title--left")
  }, void 0, /*#__PURE__*/(0,jsx_runtime_namespaceObject.jsx)(Icon_Icon, objectSpread2_default()({}, icon)), /*#__PURE__*/(0,jsx_runtime_namespaceObject.jsx)(Header_Header, objectSpread2_default()({}, header.label))), showArrow && /*#__PURE__*/jsx_default()("a", {
    href: viewMore.action.target
  }, void 0, /*#__PURE__*/jsx_default()("div", {
    className: "".concat(CarouselHeader_classname, "__title--right")
  }, void 0, /*#__PURE__*/(0,jsx_runtime_namespaceObject.jsx)(Icon_Icon, objectSpread2_default()({}, viewMore.icon))))));
};
CarouselHeader.defaultProps = {
  header: {},
  viewMore: {},
  showArrow: false,
  type: CAROUSEL_TYPES.FLAT
};
/* harmony default export */ const CarouselHeader_CarouselHeader = (CarouselHeader);
;// CONCATENATED MODULE: ./packages/CarouselClips/src/components/CarouselFooter/CarouselFooter.js








var CarouselFooter_classname = 'ui-ms-clips-carousel-footer';
var renderContent = function renderContent(_ref) {
  var icon = _ref.icon,
    label = _ref.label,
    behavior = _ref.behavior;
  var footerClassName = external_clsx_default()(CarouselFooter_classname, {
    flat: behavior === 'FLAT',
    card: behavior === 'CARD'
  });
  return /*#__PURE__*/jsx_default()("div", {
    className: footerClassName
  }, void 0, /*#__PURE__*/jsx_default()(typography_namespaceObject.Typography, {
    className: "".concat(CarouselFooter_classname, "__label"),
    variant: "h6",
    weight: behavior === 'FLAT' ? '600' : 'regular'
  }, void 0, label === null || label === void 0 ? void 0 : label.text, icon && /*#__PURE__*/(0,jsx_runtime_namespaceObject.jsx)(Icon_Icon, objectSpread2_default()({}, icon))));
};
var CarouselFooter = function CarouselFooter(_ref2) {
  var action = _ref2.action,
    icon = _ref2.icon,
    label = _ref2.label,
    behavior = _ref2.behavior;
  return action !== null && action !== void 0 && action.target ? /*#__PURE__*/jsx_default()("a", {
    className: "".concat(CarouselFooter_classname, "__anchor"),
    href: action === null || action === void 0 ? void 0 : action.target
  }, void 0, renderContent({
    icon: icon,
    label: label,
    behavior: behavior
  })) : renderContent({
    icon: icon,
    label: label,
    behavior: behavior
  });
};
CarouselFooter.defaultProps = {
  action: null,
  icon: null,
  label: {}
};
/* harmony default export */ const CarouselFooter_CarouselFooter = (CarouselFooter);
;// CONCATENATED MODULE: ./packages/CarouselClips/src/components/CarouselFlat/CarouselFlat.js










var CarouselFlat_namespace = 'ui-ms-clips-carousel';
var CarouselFlat = function CarouselFlat(_ref) {
  var id = _ref.id,
    autoplay = _ref.autoplay,
    classname = _ref.classname,
    header = _ref.header,
    viewMore = _ref.viewMore,
    items = _ref.items,
    footer = _ref.footer;
  return /*#__PURE__*/jsx_default()("div", {
    className: external_clsx_default()(CarouselFlat_namespace, classname)
  }, void 0, /*#__PURE__*/jsx_default()(CarouselHeader_CarouselHeader, {
    showArrow: true,
    header: header,
    viewMore: viewMore
  }), /*#__PURE__*/jsx_default()(Carousel_Carousel, {
    id: id,
    autoplay: autoplay,
    behavior: "FLAT",
    items: items
  }), footer && /*#__PURE__*/(0,jsx_runtime_namespaceObject.jsx)(CarouselFooter_CarouselFooter, objectSpread2_default()(objectSpread2_default()({}, footer), {}, {
    behavior: "FLAT"
  })));
};
CarouselFlat.defaultProps = {
  id: null,
  autoplay: AUTOPLAY_PROP.DEFAULT_VALUE,
  classname: null,
  header: {},
  viewMore: {},
  items: [],
  footer: {}
};
/* harmony default export */ const CarouselFlat_CarouselFlat = (CarouselFlat);
;// CONCATENATED MODULE: external "@andes/card"
const card_namespaceObject = require("@andes/card");
var card_default = /*#__PURE__*/__webpack_require__.n(card_namespaceObject);
;// CONCATENATED MODULE: ./packages/CarouselClips/src/components/CarouselCard/CarouselCard.js











var CarouselCard_namespace = 'ui-ms-clips-carousel-card';
var CarouselCard = function CarouselCard(_ref) {
  var id = _ref.id,
    autoplay = _ref.autoplay,
    classname = _ref.classname,
    header = _ref.header,
    viewMore = _ref.viewMore,
    items = _ref.items;
  return /*#__PURE__*/jsx_default()((card_default()), {
    className: external_clsx_default()(CarouselCard_namespace, classname)
  }, void 0, /*#__PURE__*/jsx_default()(card_namespaceObject.CardHeader, {
    className: "".concat(CarouselCard_namespace, "__header")
  }, void 0, /*#__PURE__*/jsx_default()(CarouselHeader_CarouselHeader, {
    header: header,
    showArrow: false,
    type: "CARD",
    viewMore: viewMore
  })), /*#__PURE__*/jsx_default()(card_namespaceObject.CardContent, {
    className: "".concat(CarouselCard_namespace, "__content")
  }, void 0, /*#__PURE__*/jsx_default()(Carousel_Carousel, {
    id: id,
    autoplay: autoplay,
    behavior: "CARD",
    items: items
  })), /*#__PURE__*/jsx_default()(card_namespaceObject.CardFooter, {
    className: "".concat(CarouselCard_namespace, "__footer")
  }, void 0, /*#__PURE__*/(0,jsx_runtime_namespaceObject.jsx)(CarouselFooter_CarouselFooter, objectSpread2_default()(objectSpread2_default()({}, viewMore), {}, {
    behavior: "CARD"
  }))));
};
CarouselCard.defaultProps = {
  id: null,
  autoplay: AUTOPLAY_PROP.DEFAULT_VALUE,
  classname: null,
  header: {},
  viewMore: {},
  items: []
};
/* harmony default export */ const CarouselCard_CarouselCard = (CarouselCard);
;// CONCATENATED MODULE: ./packages/CarouselClips/src/index.js








var CarouselClips = function CarouselClips(_ref) {
  var autoplay = _ref.autoplay,
    classname = _ref.classname,
    items = _ref.items,
    header = _ref.header,
    tracks = _ref.tracks,
    footer = _ref.footer,
    viewMore = _ref.view_more,
    type = _ref.type,
    id = _ref.id;
  var curatedProps = {
    autoplay: autoplay,
    classname: classname,
    footer: footer,
    header: header,
    items: items,
    type: type,
    viewMore: viewMore,
    id: id
  };
  (0,external_react_namespaceObject.useEffect)(function () {
    if (tracks) {
      tracks.forEach(function (track) {
        trackEvent(track === null || track === void 0 ? void 0 : track.melidata_event);
      });
    }
  }, []);
  var Component = null;
  switch (type) {
    case CAROUSEL_TYPES.FLAT:
      Component = CarouselFlat_CarouselFlat;
      break;
    case CAROUSEL_TYPES.CARD:
      Component = CarouselCard_CarouselCard;
      break;
    default:
      Component = CarouselFlat_CarouselFlat;
      break;
  }
  return items && Component ? /*#__PURE__*/(0,jsx_runtime_namespaceObject.jsx)(Component, objectSpread2_default()({}, curatedProps)) : null;
};
CarouselClips.defaultProps = {
  items: null,
  header: null,
  view_more: null,
  footer: null,
  autoplay: AUTOPLAY_PROP.DEFAULT_VALUE,
  tracks: null,
  classname: null
};
/* harmony default export */ const src = (CarouselClips);
;// CONCATENATED MODULE: ./packages/CarouselClips/src/utils/propsFormatter.js
var mplayFormatter = function mplayFormatter(data) {
  var _header$title, _action$label, _action$label2;
  var header = data.header,
    action = data.action,
    cards = data.cards,
    id = data.id;
  var items = cards.map(function (card) {
    var _image$url, _image$url2;
    var card_id = card.card_id,
      title = card.title,
      image = card.image,
      action = card.action;
    return {
      id: card_id,
      type: 'CLIP',
      label: title,
      sources: [],
      poster: {
        src_cover: '',
        src_autoplay: (image === null || image === void 0 || (_image$url = image.url) === null || _image$url === void 0 ? void 0 : _image$url.src2x) || (image === null || image === void 0 || (_image$url2 = image.url) === null || _image$url2 === void 0 ? void 0 : _image$url2.src)
      },
      action: {
        target: action === null || action === void 0 ? void 0 : action.target,
        track: {}
      }
    };
  });
  return {
    id: id,
    header: {
      icon: {
        id: 'CLIPS_LOGO',
        alt: 'Logo clips'
      },
      label: {
        text: header === null || header === void 0 || (_header$title = header.title) === null || _header$title === void 0 ? void 0 : _header$title.text
      }
    },
    view_more: {
      icon: {
        id: 'CHEVRON_RIGHT',
        alt: action === null || action === void 0 || (_action$label = action.label) === null || _action$label === void 0 ? void 0 : _action$label.text
      },
      label: {
        text: action === null || action === void 0 || (_action$label2 = action.label) === null || _action$label2 === void 0 ? void 0 : _action$label2.text
      },
      action: {
        target: action === null || action === void 0 ? void 0 : action.target,
        track: {}
      }
    },
    autoplay: false,
    items: items,
    type: 'CARD'
  };
};
var CLIENTS = {
  MPLAY: mplayFormatter
};
var getPropFormated = function getPropFormated(client, props) {
  return CLIENTS[client] ? CLIENTS[client](props) : props;
};
/* harmony default export */ const propsFormatter = (getPropFormated);
;// CONCATENATED MODULE: ./packages/CarouselClips/src/CarouselClipsAdapter.js


var CarouselClipsAdapter_excluded = ["client", "formatter"];






var CarouselClipsAdapter = function CarouselClipsAdapter(_ref) {
  var client = _ref.client,
    formatter = _ref.formatter,
    rest = objectWithoutProperties_default()(_ref, CarouselClipsAdapter_excluded);
  var propsFormated = null;
  if (client) {
    propsFormated = propsFormatter(client, rest);
  } else if (formatter) {
    propsFormated = formatter(rest);
  }
  return !client && !formatter ? null : /*#__PURE__*/(0,jsx_runtime_namespaceObject.jsx)(src, objectSpread2_default()({}, propsFormated));
};
CarouselClipsAdapter.defaultProps = {
  rest: {
    items: null,
    header: null,
    view_more: null,
    footer: null,
    autoplay: AUTOPLAY_PROP.DEFAULT_VALUE,
    tracks: null
  },
  client: null,
  formatter: null
};
/* harmony default export */ const src_CarouselClipsAdapter = (CarouselClipsAdapter);
;// CONCATENATED MODULE: ./packages/CarouselClips/index.js


/* harmony default export */ const packages_CarouselClips = (src);

module.exports["packages/CarouselClips/lib/index.production"] = __webpack_exports__;
/******/ })()
;
//# sourceMappingURL=index.production.js.map